module.exports = __webpack_public_path__ + "a2dc56970d4aab1b75de23c9f8ee71ea.png";